import { Address } from 'viem';

import { api, cacheTags, IConnectedActionParams } from 'modules/api';
import { getPublicClient } from 'modules/api/getPublicClient';
import { asAddress } from 'modules/api/utils/asAddress';
import { getWalletClient } from 'modules/api/walletClient';

import { getAccountPool } from '../methods/getAccountPool';
import { IAccountPool } from '../types';

interface IGetAccountPoolArgs extends IConnectedActionParams {
  address: Address;
  accountAddress?: Address;
}

export const {
  useGetAccountPoolQuery,
  endpoints: { getAccountPool: getAccountPoolEndpoint },
} = api.injectEndpoints({
  endpoints: build => ({
    getAccountPool: build.query<IAccountPool | null, IGetAccountPoolArgs>({
      queryFn: async ({ address, accountAddress }) => {
        const publicClient = getPublicClient();
        const handledAccountAddress = (() => {
          if (accountAddress) {
            return asAddress(accountAddress);
          }

          const walletClient = getWalletClient();

          return walletClient?.account?.address;
        })();

        return {
          data: await getAccountPool(publicClient, {
            poolAddress: address,
            accountAddress: asAddress(handledAccountAddress),
          }),
        };
      },
      providesTags: [cacheTags.account, cacheTags.pools],
    }),
  }),
});
